(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serelo-about-page"] && !Shopify.designMode) return;
  try {
    
function sereloAboutNavigation(){
  if(!document.querySelector('.serelo-about-page'))return;
  const aboutLink=document.querySelector('.serelo-nav a[href$="#about"]');
  if(aboutLink){aboutLink.href='#about-serelo';aboutLink.setAttribute('aria-current','page');}
  const newsletterLink=document.querySelector('.serelo-header a[href$="#newsletter"]');
  if(newsletterLink)newsletterLink.href='#newsletter';
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sereloAboutNavigation);}else{sereloAboutNavigation();}
document.addEventListener('shopify:section:load',sereloAboutNavigation);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serelo-hero-teal-gold"] && !Shopify.designMode) return;
  try {
    
  function retainSereloComparison() {
    if (!document.querySelector('.serelo-hero--teal-gold')) return;
    document.querySelectorAll('.serelo-header a, .serelo-footer a').forEach((link) => {
      const target = new URL(link.href, window.location.href);
      if (target.origin !== window.location.origin || target.pathname !== window.location.pathname) return;
      if (target.hash) link.setAttribute('href', target.hash);
      else if (link.classList.contains('serelo-logo') || link.classList.contains('serelo-footer__logo')) {
        const current = new URL(window.location.href);
        current.hash = '';
        link.href = current.href;
      }
    });
  }
  retainSereloComparison();
  document.addEventListener('shopify:section:load', retainSereloComparison);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serelo-journal-page"] && !Shopify.designMode) return;
  try {
    
  function initialiseSereloJournal() {
    document.querySelectorAll('[data-serelo-journal]').forEach((journal) => {
      if (journal.dataset.ready) return;
      journal.querySelectorAll('[data-preview-filter]').forEach((filter) => {
        filter.addEventListener('click', (event) => {
          event.preventDefault();
          journal.querySelectorAll('[data-preview-filter]').forEach((item) => item.removeAttribute('aria-current'));
          filter.setAttribute('aria-current', 'page');
        });
      });
      document.querySelectorAll('.serelo-header a').forEach((link) => {
        if (new URL(link.href, window.location.href).hash === '#newsletter') link.setAttribute('href', '#newsletter');
      });
      journal.dataset.ready = 'true';
    });
  }
  initialiseSereloJournal();
  document.addEventListener('shopify:section:load', initialiseSereloJournal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["serelo-story"] && !Shopify.designMode) return;
  try {
    
  function initialiseSereloStory() {
    document.querySelectorAll('[data-serelo-story]').forEach((story) => {
      if (story.dataset.ready) return;
      const headings = story.querySelectorAll('.serelo-story__body h2');
      const sidebar = story.querySelector('.serelo-story__sidebar');
      const list = sidebar.querySelector('ol');
      headings.forEach((heading, index) => {
        if (!heading.id) heading.id = 'serelo-story-heading-' + index;
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#' + heading.id;
        link.textContent = heading.textContent;
        item.append(link);
        list.append(item);
      });
      if (headings.length) {
        sidebar.hidden = false;
        sidebar.querySelector('details').open = window.matchMedia('(min-width: 990px)').matches;
      }
      document.querySelectorAll('.serelo-header a').forEach((link) => {
        if (new URL(link.href, window.location.href).hash === '#newsletter') link.setAttribute('href', '#newsletter');
      });
      story.dataset.ready = 'true';
    });
  }
  initialiseSereloStory();
  document.addEventListener('shopify:section:load', initialiseSereloStory);

  } catch(e) { console.error(e); }
})();
})();
